import { PropsWithChildren, ReactElement, useId } from 'react';

import { ActionSheetToggle } from './ActionSheetToggle/ActionSheetToggle';
import { ActionSheetMenu } from './ActionSheetMenu/ActionSheetMenu';
import { ActionSheetContext } from './ActionSheet.context';

export type ActionSheetProps = PropsWithChildren<{}>;

interface ActionSheetComponent {
  (props: ActionSheetProps): ReactElement;
  Toggle: typeof ActionSheetToggle;
  Menu: typeof ActionSheetMenu;
}

export const ActionSheet: ActionSheetComponent = ({ children }) => {
  const id = useId();

  return (
    <ActionSheetContext.Provider value={{ id }}>
      {children}
    </ActionSheetContext.Provider>
  );
};

ActionSheet.Toggle = ActionSheetToggle;
ActionSheet.Menu = ActionSheetMenu;
